import React from "react";
import PropTypes from "prop-types";
import Tippy from "@tippyjs/react";
import { followCursor } from "tippy.js";
import { ARROW } from "../constants/overlay";

const POSITIONS = [
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end",
  "right",
  "right-start",
  "right-end",
];

const Tooltip = ({
  content,
  children,
  theme = "dark",
  disabled = false,
  placement,
  position = "auto",
  interactive = false,
  ...otherProps
}) => {
  return (
    <Tippy
      role="tooltip"
      theme={theme}
      content={content}
      arrow={ARROW}
      disabled={disabled}
      animation={"scale-subtle"}
      placement={placement || position}
      plugins={[followCursor]}
      interactive={interactive}
      duration={[100, 200]}
      zIndex={100001}
      {...otherProps}
    >
      {children}
    </Tippy>
  );
};

Tooltip.propTypes = {
  /**
   * The component to be rendered inside the popup.
   */
  content: PropTypes.node,
  /**
   * Tooltip popup will be shown when mouse is hovered over this component.
   */
  children: PropTypes.node,
  /**
   * To display Tooltip in dark or light theme. By default the theme is dark.
   */
  theme: PropTypes.oneOf(["dark", "light", "error"]),
  /**
   * To specify whether the tooltips is disabled or not.
   */
  disabled: PropTypes.bool,
  /**
   * To specify the position where the tooltip should appear.
   */
  position: PropTypes.oneOf(POSITIONS),
  /**
   * Whether the tooltip should follow along the element according to cursor movement.
   */
  followCursor: PropTypes.oneOf(["auto", "horizontal", "vertical"]),
  /**
   * To specify whether the contents inside the tooltip can be interacted with by the user.
   */
  interactive: PropTypes.bool,
};

export default Tooltip;
